import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';

import { t } from 'ember-intl';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import { isEmpty, not } from 'ember-truth-helpers';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import type { AssetFolder } from '../types';
import styles from './styles.module.css';

const bem = getBem(styles);

interface UploadHintSignature {
  Args: {
    folder?: AssetFolder | null;
  };
  Element: HTMLDivElement;
}

<template>
  <div
    class={{bem (hash is-visible=(not (isEmpty @folder)))}}
    role='status'
    aria-live='polite'
    aria-atomic='true'
    data-test-upload-hint
    ...attributes
  >
    {{#if @folder}}
      {{svgJar
        'upload'
        class=(bem 'upload-icon')
        aria-hidden='true'
        focusable='false'
      }}
      <div class={{bem 'message'}}>
        {{t 'record_explorer.for.asset.upload_hint.drop_into_folder'}}
        <div class={{bem 'folder'}} data-test-upload-hint-folder>
          {{svgJar
            'folder-open'
            class=(bem 'folder-icon')
            aria-hidden='true'
            focusable='false'
          }}
          {{@folder.label}}
        </div>
      </div>
    {{/if}}
  </div>
</template> satisfies TOC<UploadHintSignature>;
